import React from "react";
import axios from "axios";
import APIURL from "../../../Main/apiurl";
import { json } from "react-router-dom";

const create_home_feature = async (home_feature) => {
  try {
    let data = new FormData();
    data.append("image", home_feature?.image[0]);
    data.append("title", home_feature?.title);
    data.append("description", home_feature?.description);
    data.append("status", home_feature?.status);

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/create-home-feature`,
      data,
      config
    );

    if (response?.data?.status_code == 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    } else {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

const update_home_feature = async (home_feature) => {
  try {
    let data = new FormData();
    data.append("id", home_feature?.id);
    data.append("image", home_feature?.image[0]);
    data.append("title", home_feature?.title);
    data.append("description", home_feature?.description);
    data.append("status", home_feature?.status);

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/update-home-feature`,
      data,
      config
    );

    if (response?.data?.status_code == 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    } else {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

const get_home_feature = async (home_feature) => {
  try {
    const data = {
      id: home_feature?.id,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-home-feature`,
      data,
      config
    );

    if (response?.data?.status_code == 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    } else {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

const get_all_home_features = async (home_feature) => {
  try {
    const data = {
      search: home_feature?.search,
      sort: home_feature?.sort,
      unit: home_feature?.unit,
      category: home_feature?.category,
      brand: home_feature?.brand,
      type: home_feature?.type,
      status: home_feature?.status,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-home-features `,
      data,
      config
    );

    if (response?.data?.status_code == 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    } else {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

export {
  create_home_feature,
  update_home_feature,
  get_home_feature,
  get_all_home_features,
};
